import React from "react";

export default (calculateTotalPages, Component) => {
  var klass = class Pageable extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        page: 1
      };
      this.nextPage = this.nextPage.bind(this);
      this.previousPage = this.previousPage.bind(this);
    }

    nextPage() {
      var { page } = this.state;
      var totalPages = calculateTotalPages(this.props);
      this.setState({ page: Math.min(page + 1, totalPages) }); // eslint-disable-line react/no-set-state
    }

    previousPage() {
      var { page } = this.state;
      this.setState({ page: Math.max(page - 1, 1) }); // eslint-disable-line react/no-set-state
    }

    render() {
      var { page } = this.state;
      return <Component {...this.props} nextPage={this.nextPage} page={page} previousPage={this.previousPage} />;
    }
  };
  klass.displayName = "Pageable(" + Component.name + ")"; // eslint-disable-line react/static-property-placement
  return klass;
};
